export default {
    lang: {
        chinese: '简体中文',
        english: 'English',
        tibet: '藏文',
    },
    menu: {
        dashboard: '首页',
        abstract: '藏博概况',
        'ab_history': '历史沿革',
        'ab_structuring': '机构设置',
        'ab_words': '馆长致辞',
        'ab_events': '大事记',
        'ab_expansion_project': '改扩建工程',
        exhibition: '展览展讯',
        'ex_zhaunti': '专题展览',
        'ex_huimou': '特展回眸',
        'ex_allsence': '全景漫游',
        zangpinDisplay: '藏品鉴赏',
        'zp_treasures': '珍品赏析',
        'zp_fast_look': '文物快览',
        'zp_collection_donation': '文物征集与捐赠',
        cultural: '文创产品', //文创产品
        'cul_beautity': '文创精品',
        'cul_news': '文创动态',
        educationActivity: '教育活动',
        'edu_latest_activities': '最新活动',
        'edu_special_activities': '专题活动',
        'edu_review_activities': '活动回顾',
        'edu_children': '少儿专区',
        'edu_Volunteers': '志愿者之家',
        academic: '学术研究',
        'academic_institutions': '学术机构',
        'academic_book': '学术期刊',
        'academic_classroom': '学术讲堂',
        science_technology: '科技保护',
        'sci_workstation': '联合工作站简介',
        'sci_achievements': '保护修复成果',
        'sci_knowledge': '科普知识',
    },
    common: {
        findMore: '更多',
        findDetails: '查看详情',
        detailTitle: '详情',
        last: '上一步',
        telPhone: '手机号',
        telPhoneTips: '请输入手机号',
        formatError: '格式错误',
        phoneError: '手机号码格式错误', //
        idCardError: '身份证号码格式错误', //
        others: '其他', //
        time: '发布时间',
        close: '关闭',
        refreshed: '刷新成功', //
        LoadMore: '加载更多',
        noMore: '暂无更多',
        return: '返回首页',
        prevPage: '上一篇', //
        nextPage: '下一篇', //
        NoPicture: '暂无图片',
    },
    search: {
        search_btn: '搜索',
        search_text: '在此输入关键词语'
    },
    home: {
        MuseumNews: '文博快讯',
        Notice: '通知公告',
        OpeningClosingTime: '开闭馆时间',
        TrafficRoutes: '交通路线',
        expansionProject: '改扩建工程',
        goverPublic: '党务政务公开',
        questionnaire: '问卷调查',
        messageBoard: '留言板',
        policies: '政策法规',
        mailBox: '馆长信箱',
        beautity: '文创精品',
        friendLink: '友情链接',
        addressTitle: '博物馆地址',
        addressContent: '西藏自治区拉萨市城关区罗布林卡路19号',
        contactNumber: '联系电话',
        eduActivity:"教育活动",
        zhanLanRecommend:"展览推荐",
        speech:"最新讲座"
    },
    news: {
        museumNews: '文博快讯',
        notice: '相关公告',
    },
    //留言板
    msgBoard: {
        title: '留言板',
        textTitle: '西藏博物馆公众留言板',
        tips: '请准确填写以下资料，我们将尽快作出回复，谢谢！西藏博物馆期待您的咨询和宝贵建议！',
        name: '姓名',
        phoneNumber: '手机号码',
        suggestion: '意见建议',
        vertifyCode: '请输入验证码',
        realNamePlaceholder: '此处填写真实姓名',
        realphoneNumberPlaceholder: '此处填写真实手机号码',
        textarea: '在此处填写您的咨询问题或宝贵建议',
        namePlease: '请输入姓名',
        phoneNumberPlease: '请输入手机号',
        suggestionPlease: '请填写您的宝贵意见',
        vertifyCodePlease: '请输入验证码',
        vertifyCodeError: '验证码错误',
        submit: '提交留言',
        submitSuccess: '留言成功',
        submitFail: '留言失败',
        FillInAgain: '重新填写',
    },
    //问卷调查
    questionnaire: {
        title: '问卷调查',
        finishPlease: '请完成答卷', //
        noFrequentlyPlease: '请不要频繁提交', //
        submit: '提交答案',
        submitSuccess: '提交成功',
        submitFail: '操作失败',
        Resubmit: '重新提交',
    },
    //馆长信箱
    mailBox: {
        title: '西藏博物馆馆长信箱',
        text: '为了更好的反映民声，现将馆长信箱对广大用户开放，欢迎您对西藏博物馆的工作提出宝贵的建议意见。',
        box: '馆长信箱'
    },
    //票务预约
    appointment: {
        title: '票务预约',
        notice: '票务预约须知',
        networkApply: '网上预约',
        today: '今天',
        closed: '闭馆',
        chooseDatePlease: '请您先选择预约日期',
        nowApply: '立即预约',
        chooseDate: '选择参观日期',
        infoTitle: '参观者信息',
        fillInfo: '填写个人信息',
        visitDate: '参观时间',
        tips1: '每名成人最多可携带两名1.3m以下的儿童。',
        tips2: '网上预约或注册用户时，请务必提供真实有效身份信息， 并正确填写， 如填写错误， 将有可能无法领取参观票。',
        addPerson: '添加参观者',
        addPersonPlease: '请先添加参观者',
        name: '姓名',
        idType: '证件类型',
        idNumber: '证件号码',
        namePlease: '请输入姓名',
        idTypePlease: '请选择证件类型',
        idNumberPlease: '请输入证件号码',
        delete: '删除',
        idCard: '身份证',
        passport: '护照',
        reset: '重置',
        confirmAdd: '确定添加',
        confirmOrder: '确认订单信息',
        finishApply: '完成票务预约',
        success: '恭喜，预约成功',
        successNotice: '请于参观当日持有效证件入馆参观'
    },
    //展览展讯
    exhibition: {
        special: '专题展览',
        review: '特展回眸',
        allsence: '全景漫游',
        detail: '展览详情',
        openDate: '开展时间',
        closeDate: '闭展时间',
        position: '展览位置',
        area: '展览面积',
        theme: '展览主题',
        struct: '展览结构',
        content: '展览内容',
        relics: '展览文物',
        fullView: '展览全景',
        changSheView: '常设展览',
        linShiView: '临时展览',
        zhuanTiView: '专题展览'
    },
    //展品
    exhibits: {
        treasure: '精选展品',
        fastLook: '文物快览', //文物快览
        collection: '征集捐献', //文物征集与捐赠
        collectionRelics: '文物征集',
        donationRelics: '文物捐赠',
        statues:'造像',
        thangka:'唐卡',
        historicalRelics:'历史文物',
        porcelains:'瓷器',
        jadeArticles:'玉器',
        religiousImplements:'法器',
        ancientBooks:'古籍文献',
        folkCustoms:'民俗',
        others:'其他',
    },
    // 文创
    cultural: {
        beautity: '文创精品',
        product: '文创产品',
        news: '文创动态'
    },
    //活动
    activity: {
        latest: '最新活动',
        special: '专题活动',
        review: '活动回顾',
        children: '少儿专区',
        volunteers: '志愿者风采',
        home: '志愿者之家',
        volunteersTitle: '西藏博物馆面向全区招募志愿者',
        volunteersBrief: '西藏博物馆此次志愿者招募接受常年报名，而且名额不限。申请人要求必须遵守国家法律法规，热爱祖国、热心博物馆公益事业。',
        joinUs: '加入我们',
        time: '活动时间',
        details: '活动详情',
        download: '下载报名附件'
    },
    //学术
    academic: {
        institutions: '学术机构',
        book: '学术期刊',
        classroom: '学术讲堂',
        downloadNum: '下载量',
        download: '点击下载',
        noVideo: '此视频暂无法播放，请稍后再试',
    },
    //科技保护
    protection: {
        workstation: '联合工作站',
        achievements: '保护修复成果',
        knowledge: '科普知识',
        knowledgeTitle: '藏品科普知识',
        knowledgeContent: '博物馆在青少年教育中有着自身独特的优势， 不同时代、不同风格的藏品都是艺术与美的载体，让青少年走进博物馆就仿佛把他们带进美的艺术殿堂。相比于传统的浏览性参观和导览性讲解，青少年更渴望形式活泼、艺术性与趣味性广泛的教育内容。',
        restorationTitle: '藏品修复与保护',
        restorationContent: '西藏博物馆作为一家综合性民族博物馆，其珍藏文物数量庞大，种类繁多，对其进行科学分类是有效利用文物信息和保护藏品本体的前提。西藏博物馆文物入库后，文保人员对其进行科学分类、登记和编目，首先按文物功用、材质、藏量等保存特性将全部藏品分为造像、唐卡、丝绸、法器、古籍、瓷器、玉器、珐琅器、银器等十九类，然后逐一编号、拍照、建立藏品总登记帐。随着西藏博物馆藏品优势、 研究优势、 展览优势的凸显， 馆领导越来越重视文物的科技保护， 先后陆续派相关专业人员到内地兄弟馆学习先进文物保护修复技术及理念， 参加国家文物局主办的纺织品专题保护修复培训班， 并于2012年在我馆成立了唐卡保护工作室。',
        compare: '修复前后对比',
        before: '修复前',
        after: '修复后',
    }
}